/* eslint-disable no-console */

import queryString from 'querystring';
import Resources from './helpers/resources';

export default class Configuration {
    static configure() {
        // How we want to configure things depends on where this app is running,
        // and where the services we want to access live.
        //
        // 1. When running on a developer's machine, using a mock server we want
        //    to use a hard-coded config from
        //
        //       helpers/local-resource-config.js
        //
        // 2. When running on a developer's machine, but we want to use back-end
        //    services on demo, QA or live, we want to get the configuration from
        //    the configuration of the host app.
        //
        // 3. When running on demo, QA or live, the configuration will be injected
        //    based on the host app's configuration, but can be overridden by query
        //    parameters.
        //
        // We determine which situation we have by looking at the window location
        // URL and the query parameters, and whether there is a pppAppConfig property
        // on the window object.

        const location = window.location;
        const runningOnDeveloperMachine = /^https?:\/\/localhost/.test(location);
        const queryParams = location.search;
        const query = queryParams.replace('?', '');
        const params = queryString.parse(query);

        if (runningOnDeveloperMachine) {
            Configuration.configureForDeveloperMachine(params);
        } else {
            Configuration.configureForRemoteHost(params);
        }
    }

    static configureForDeveloperMachine(params) {
        let envName = params.env;

        if (!envName) {
            console.log('Configuration.configureForDeveloperMachine() - you did not provide an "env" query' +
                ' parameter, so I am assuming you want to talk to live.');

            envName = 'live';
        }

        const credentials = Configuration.getCredentials(params);

        if (envName === 'local' || Configuration.weHaveUsableCredentials(credentials)) {
            Resources.initialise(envName, credentials);
        }
    }

    static configureForRemoteHost(params) {
        // eslint-disable-next-line no-underscore-dangle
        const config = window._env_;
        const envName = config.env || 'live';
        const credentials = Configuration.getCredentials(params);

        if (!config.BaseName) {
            console.log('Configuration.configureForRemoteHost() - your pppAppConfig does not' +
                ' include a BaseName item; we will assume it should be blank.');

            config.BaseName = '';
        }

        if (Configuration.weHaveUsableCredentials(credentials)) {
            Resources.initialise(envName, credentials);
            Resources.env.setConfiguration(config);
        }
    }

    static getCredentials(params) {
        const credentials = {};
        const items = ['authToken', 'username', 'password'];

        for (const paramName in params) {
            const value = params[paramName];

            for (const item of items) {
                if (paramName.toLowerCase() === item.toLowerCase()) {
                    credentials[item] = value;
                }
            }
        }

        return credentials;
    }

    static weHaveUsableCredentials(credentials) {
        let usableCredentials = false;

        if (credentials.authToken) {
            usableCredentials = true;
        } else if (credentials.username && credentials.password) {
            usableCredentials = true;
        }

        if (!usableCredentials) {
            /* eslint-disable no-console */
            console.error('EntryApp.configureForDeveloperMachine() - to execute, we need either an authToken or' +
                ' a username/password pair.  After combining data from window.pppAppConfig and the query' +
                ' parameters, I still do not have what I need. The app will probably not function correctly if' +
                ' it requires any 3P resources.');
            /* eslint-disable no-console */
        }

        return usableCredentials;
    }
}



// WEBPACK FOOTER //
// ./app/config.js